import script from "./ListaReclamos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaReclamos.vue?vue&type=script&setup=true&lang=js"

import "./ListaReclamos.vue?vue&type=style&index=0&id=3ca0450c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ca0450c"]])

export default __exports__